<template>
<div>
  <Modal class="modal-reg" width="570" v-model="showExamine" :closable="false" :mask-closable="false" >
       <div slot="header" class="modal-reg-title">
         <img src="../assets/lin_icon.png" alt="">   <span>环节确认</span> <!--<span class="tips">PS : 接包方发起环节确认请求!</span>--> <Icon  type="md-close" @click="closeWindow"/>
       </div>
       <div class="modal-contaner">
           <p>环节名称：{{$parent.FlowInfo.Title}}-{{$parent.FlowInfo.Rate}}%</p>
           <p>环节描述：{{$parent.FlowInfo.Content}}</p>
           <div>
               <ul>
                   <li v-for="(item,index) in this.$parent.FlowInfo.flowProcess" :key="index">
                       <img src="../assets/name_icon.png" alt="">
                       <div>
                           <p><span>{{item.ContectName}}</span><span>2019-1-23 14:21</span></p>
                           <div>
                               <p><span v-if="item.TypeID == 2" class="modify-icon">返修</span>{{item.Content}}</p>
                               <div v-for="(v,i) in item.Attach" :key="i">
                                    <Icon type="md-attach" /><a target="_blank" :href="v.url">{{v.name}}</a>
                               </div>
                           </div>
                       </div>
                   </li>
               </ul>
           </div>
           <div class="enter">
               <textarea v-model="content"></textarea>
           </div>
           <div style="margin-top:20px;border-top:none">
               上传附件：
               <Upload style="margin-top:5px;" :action="uploadUrl" :on-success="successValid" :on-remove="deleValid" >
                    <Button type="primary" >点击上传</Button>
                </Upload>
           </div>
           <div class="identy" v-if="UserType == 2 || UserType == 3">
               <!-- <p>项目结余 ： <i>5012.00 元</i></p> -->
               <p><span>预支款项 ：</span><Input v-model="Fee" style="width:50%;"/><span>0为不预支</span></p>
           </div>
       </div>
       <div slot="footer">
           <Button  @click="submit(3)" type="success" v-if="UserType==2 || UserType == 3"> 审核通过</Button>
           <Button  @click="submit(2)"  type="error"  v-if="UserType==2 || UserType == 3">退回返修</Button>
           <Button  @click="closeWindow">取消</Button>
           <Button type="primary" @click="submit(1)" v-if="UserType==1">提交审核</Button>
       </div>
    </Modal>
</div>
</template>
<script>
export default {
    props:{
        showExamine:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            uploadUrl:this.$base,//上传地址
            content:'',//文本内容
            File:[],//文件列表
            Fee:'',
            UserType:1,//1.接包 2发包
        }
    },
    mounted(){
       	if(this.$getLS('AdminInfo')){
            this.UserType=JSON.parse(this.$getLS('AdminInfo')).Type
        }
    },
    methods:{
        submit(SubmitType){//SubmitType提交类型：1、待确认，2、返修，3、确认
            this.$emit('click',SubmitType,this.content,this.File,this.Fee)
        },
         closeWindow(){
             this.$emit('closeWindow');
        },
         //删除附件成功回调函数
        deleValid(res){
            for (let i = 0; i < this.File.length; i++) {
                if (this.File[i].Path == res.Path) {
                    this.File.splice(i,1);
                    break;
                }
            }
        },
        //上传附件成功回调函数
        successValid(res, file){//附件上传成功
            if(res.code == 1){
                this.File.push({'name':file.name,'url':res.Path});
            }
        },
    }
}
</script>
<style lang="less" scoped>
.modal-reg{
    //  text-align: center;
  .modal-reg-title{
        background-color:#01AAE3;
        // text-align: center;
        padding:20px;
        color: #fff;
        font-size: 22px;
        overflow: hidden;
        img{float: left;
        }
        >span{
            float:left;
            margin-left: 10px;
            margin-top:5px;
        }
        .tips{
            color: #FFFF00;
            font-size: 12px;
            margin-top: 10px;
        }
        i{
            float: right;
            font-size: 25px;
             cursor: pointer;
        }
    }
    .modal-contaner{
        padding:20px;
        >p{
            font-size: 12px;
            color: #738395;
            margin-bottom:10px;
        }
        >div{
            border-top:1px solid #EFF3F6;
            ul{
                li{
                    overflow: hidden;
                    margin-top: 15px;
                    >img{
                        float: left;
                    }
                    >div{
                        margin-left: 2%;
                        float: left;
                        width: 94%;
                        >p{
                            color: #637283;
                            overflow: hidden;
                            line-height: 30px;
                            font-size: 12px;
                            span{
                                float: left;
                            }
                            >span:nth-child(2){
                                  float: right;
                            }
                        }
                        >div{
                            padding:10px;
                            background-color: #EFF3F6;
                            border-radius: 3px;
                            >p{
                                margin-bottom: 20px;
                            }
                            >div{
                                border-top:1px solid #D3DEE7;
                                padding-top: 10px;
                                i{
                                    transform: rotate(45deg);
                                    font-size:20px;
                                }
                                a{
                                    color: #333333;
                                    text-decoration: underline;
                                    margin-left: 5px;
                                
                                }
                            }

                        }
                    }
                }
            }
        }
        >.enter{
            border:1px solid #8ADFFF;
            margin-top: 20px;
             padding:10px;
            textarea{
                border:none!important;
                display: block;
                width: 100%;
                height: 80px;
                outline:none; 
                resize:none; 
               
            }
            p{
                overflow: hidden;
                a{
                    color: #333;
                    text-decoration: underline;
                    float: right;
                        margin-right: 10px;
                }
                .ivu-upload{
                    float: right;
                          .icon-uplod{
                background-color: #57D1FF;
                width: 26px;
                height: 26px;
                color: #fff;
                display: block;
                text-align: center;
                line-height: 26px;
                
                >i{
                    font-size: 20px;
                    transform: rotate(45deg);
                }
            }
                }
           

            }
           
        }
            .identy{
      
        border:none;
        >p{
              margin-top: 20px;
            font-size: 12px;
            color:#637283 ;
            display: flex;
            >i{
                color: #FF7F00;
                font-style: normal;
            }
         
            >span{
                line-height: 30px;
            }
        }

    }
        
    }

}

.modify-icon {
    display: inline-block;
    color: #fff;
    background-color: #e13d13;
    padding: 1px 6px;
    border-radius: 5px;
    margin-right: 10px;
}
  
</style>



// WEBPACK FOOTER //
// src/components/Link-modal.vue